import React from "react";
import { FaRegFileAudio } from "react-icons/fa";
const AudioUpdate = ({ video, setPlayAudio }) => {
  return (
    <div className="thumb lightborder" onClick={() => setPlayAudio(video.id)}>
      <FaRegFileAudio className="audioIcon" />
      <div className="audioTitle">
        <div className="audioInner">
          <div className="name">{video.title}</div>
        </div>
      </div>
    </div>
  );
};

export default AudioUpdate;
